import moment from 'moment'
import Decimal from 'decimal.js'

// todo 时间处理
export const UniteYMDHms = (time: string) => { // 2019-09-05 13:14:52
  if (!time) {
    return ''
  }
  return moment(time).format('YYYY-MM-DD HH:mm:ss')
}
export const UniteHmsYMD = (time: string) => { //13:14:52 2019-09-05
  if (!time) {
    return ''
  }
  return moment(time).format('HH:mm:ss YYYY-MM-DD')
}
export const UniteYMD = (time: string) => { // 2019-09-05
  if (!time) {
    return ''
  }
  return moment(time).format('HH:mm:ss YYYY-MM-DD')
}
// 数处理
export const UniteTowPlaces = (num: number | string) => { // 保留两位小数 （12.3> 12.30）
  return new Decimal(num).toFixed(2)
}
export const UnitePercentage = (num: number | string) => { // (小数)转百分比(保留两位小数) （0.1 => 10.00%）
  return new Decimal(num).mul(100).toFixed(2) + '%'
}